import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getCurrentDateTime, request, BASE_URL } from '../../../../../utils';
import { useEffect, useState } from 'react';
import { BALANCE_REGISTER_REPORT_TYPE, REPORT_TYPE } from '../../../../../constants/dropdown';
import { CollectionSummaryReport } from './CollectionSummaryReport';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { toast } from 'react-toastify';


const initialSchemeAllotmentDataObj = { data: [], loading: false };

export const BalanceRegisterReport = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split("/").pop();
  const [openPrint, setOpenPrint] = useState(false);
  const [userdata, setUserData] = useState([]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;
  const user = JSON.parse(localStorage.getItem('user'));
  // console.log("HELLLLLLO USERSSSS", user)

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const response = await axios.get(`${BASE_URL}/print/hospital/inpatient-management/balance-register-report?refId=${JSON.stringify({ report: watch('report'), from_date: watch('from_date'), to_date: watch('to_date') })}`)
     console.log("API url data", response);
     if (response.data.success) {
     const filteredData = response?.data?.data?.indoorServiceData?.data || [];
      if (filteredData.length > 0) {
        console.log("Conditional Data", filteredData);

        const fileName = `Balance_Register_Report_${JSON.stringify(watch('from_date'))}_to_${JSON.stringify(watch('to_date'))}`;
        
        const formattedData = filteredData.map((item, index) => ({
          "Sr. No.": index + 1,
          'Patient Name': (`${item?.patient?.name_suffix} ${item?.patient?.first_name} ${item?.patient?.last_name}`),
          'Uhid No.': item?.patient?.uhid,
          'Adm No': item?.ipd_no,
          'Doctor Name': item?.patient?.consultant?.name,
          'Sponsor': item?.patient?.sponsor?.name,
          'Adm Date': formatDate(item?.date),
          'Bill Amount': item?.total_amt,
          'Room Change': item?.total_room_charge,
          'Rec Amount': item?.total_recd,
          'Total Refund': item?.total_refund,
          'Bal Amount': item?.balance_amt,
          
        }));
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      } else {
        toast(`No Data Found For These Filter`, { variant: 'error' });
      }
    } else {
      toast(`Something Went Wrong`, { variant: 'error' });
    }
  };


  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Balance Register Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('report')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ report: watch('report'), from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    ) } >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  id={`${lastPathSegment}Print`}
                  disabled={!watch('report')}
                  onClick={handleExcelReport} >
                  Download Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%', boxShadow: '0px 2px 10px #0099ff' }}>
            <Grid container spacing={2}>
              <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 1 }} name="from_date" type="date" />
                </Stack>
                <Stack direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 1 }} name="to_date" type="date" />
                </Stack>
                <Stack direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}> Type</Typography>
                  <SelectTag formControlSX={{ flex: 1 }} 
                  name="report" 
                  menus={[{name: 'All', _id: 'all'}, {name: 'Patient', _id: 'patient'}, ...userdata.map((data) => ({
                    ...data,
                    name: `${data.BALANCE_REGISTER_REPORT_TYPE}`, _id: `${data.BALANCE_REGISTER_REPORT_TYPE}`
                  }))]} />
                </Stack>
              </Grid>
            </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <CollectionSummaryReport />
      </Dialog>
    </>
  );
};
